const CURVA_TIPO = {
    PRE: { id: '1', descricao: 'Pré' },
    POS: { id: '2', descricao: 'Pós' },
    PRE_POS: { id: '3', descricao: 'Pré/Pós' }
};
module.exports = CURVA_TIPO;
